import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from 'react-select'
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from 'sweetalert2';
import { formatDate, SubmitButton, TextBox } from "../../Components/InputElements";
import { NoRecords } from "../../Components/Shimmer";
import TooltipComponent from "../../Components/TooltipComponent";
import { decodeData, formatDateAndTime } from "../../Constants/constants";


class AssignGoals extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      reporting_manager: '1',
      location_id: "",
      department_id: "",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      loadingSearch: false,
      loadingFilter: false,
      postLoading: false,
      get_location_row: [],
      goals_rows: [],
      pms_cycle_rows: [],
      department_row: [],
      selectedEmployeeId: null,
      selectedRows: [],
      agency_verification_status: '',
      empOptions: [],
      emp_keyword: '',
      selected_rm_employee_id: '',
      reporting_manager_employee_id: '',
      assignGoalsModal: false,
      goal_id: '',
      pms_cycle_id: '',
      start_date:"",
      end_date:"",
      viewEmployeeGoalsLogs: false,
      decodedData: [],

    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
    //   this.GetDepartmentMasters();
    //   this.GetEmployeesOptionList();
    //   this.GetLocationMasters();
      this.GetDepartmentAndLocationList();
      this.GetList();
      this.GetGoalsList();
      this.GetPMSCycleList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }
  GetEmployeesOptionList = () => {
    if (this.state.emp_keyword) {
      const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;
      try {
        axios
          .get(`${apiURL}PMSRouter/GetEmployeesListForGoalAssign`, { params: { keyword: this.state.emp_keyword }, headers })
          .then((response) => {
            if (response.data.success === true) {
              this.setState({ empOptions: response.data.data })
            } else {
              this.setState({ empOptions: [] })
            }
          })
      } catch (error) {
        console.log("error", error)
      }
    } else {
      console.log("no emp keyword")
    }
  }
  GetDepartmentAndLocationList = () => {
      const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;
      try {
        axios
          .get(`${apiURL}PMSRouter/GetDepartmentAndLoactionList`, {headers})
          .then((response) => {
            console.log("GetDepartmentAndLoactionList ~ response.data ===>", response.data);
            
            if (response.data.success === true) {
              
              this.setState((prevState) => ({
                department_row: response.data?.department_result.map((row) => ({
                  value: row.department_id,
                  label: row.department_title,
                })),
              }));
              this.setState((prevState) => ({
                get_location_row: response.data?.location_result.map((row) => ({
                  value: row.location_id,
                  label: row.location_title,
                })),
              }));
               console.log("this.state.department_row ==>",this.state.department_row);
               
            } else {
              this.setState({ department_row: [] })
              this.setState({ get_location_row: [] })
            }
          })
      } catch (error) {
        console.log("error", error)
      }  
  }
  GetGoalsList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}PMSRouter/GetGoalsList`, {
        params: {
          limit: 999,
          page: 1,
          activated:"1",
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          department_id: this.state.department_id,
          location_id: this.state.location_id,
          reporting_manager_employee_id: this.state.reporting_manager_employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
            const tempRows= data?.data.map((val)=>{
                return { value: val?.goal_id, label: val?.goal_title }
            })
          this.setState({
            goals_rows: tempRows,
          });
        } else {
          this.setState({ loadingList: false, loadingSearch:false });
        }
      })
      .catch((error)=>{
        console.log(error);
      })
      .finally(this.setState({ loadingList: false, loadingSearch:false }));
      
  };
  GetPMSCycleList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}PMSRouter/GetPMSCycleList`, {
        params: {
          limit: 999,
          page: 1,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          department_id: this.state.department_id,
          location_id: this.state.location_id,
          reporting_manager_employee_id: this.state.reporting_manager_employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
            const getCalendarsRows = data.data.map((row) => ({
                value: row.pms_cycle_id,
                fromDate: row.from_date ? new Date(row.from_date) : null,
                toDate: row.to_date ? new Date(row.to_date) : null,
                label: (
                    <span>
                        {formatDate(row.from_date)} <i className="ri-arrow-left-right-line" /> {formatDate(row.to_date)}
                    </span>
                ),
            }));
          this.setState({
            pms_cycle_rows: getCalendarsRows,
          });
        } else {
          this.setState({ loadingList: false, loadingSearch:false });
        }
      })
      .catch((error)=>{
        console.log(error);
      })
      .finally(this.setState({ loadingList: false, loadingSearch:false }));
      
  };
  handleRadioChange = (name, value) => {

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));

  };


  // GetDepartmentMasters = () => {
  //   const { apiURL, apiHeaderJSON } = this.context;
  //   const headers = apiHeaderJSON;
  //   axios
  //     .get(`${apiURL}PMSRouter/GetMasters`, { headers })
  //     .then((response) => {
  //       var data = response.data.data.department;
  //       if (response.data.success === true) {
  //         this.setState((prevState) => ({
  //           department_row: data.map((row) => ({
  //             value: row.department_id,
  //             label: row.department_title,
  //           })),
  //         }));
  //       }
  //     });
  // };


  GetLocationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}PMSRouter/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.location;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Location: data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}PMSRouter/GetEmployeesListForGoalAssign`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          department_id: this.state.department_id,
          location_id: this.state.location_id,
          reporting_manager_employee_id: this.state.reporting_manager_employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        console.log("GetEmployeesListForGoalAssign =>",data);
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
          });
        }
        this.setState({ loadingList: false, loadingSearch:false, loadingFilter: false });
      }).catch((error)=>{
        console.log(error);
        this.setState({ loadingList: false, loadingSearch:false, loadingFilter: false });
        Swal.fire({ 
        title: `<strong>Failed</strong>`, 
        text: error?.message, 
        icon: 'error', 
        showConfirmButton: true,
        allowOutsideClick:false, 
        });
      });
  };

  handleSubmit = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    this.setState({ postLoading:true });
    const formData = {
      employee_list: this.state.selectedRows,
      goal_id: this.state.goal_id,
      employee_id: this.state.employee_id,
      pms_cycle_id: this.state.pms_cycle_id,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
    };
    axios.post(`${apiURL}PMSRouter/AssignGoalToEmployees`, formData, { headers })
    .then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({ loadingList: true,postLoading:false,assignGoalsModal:false,
            goal_id: '', 
            pms_cycle_id: '', 
            start_date: '', 
            end_date: '', 
            selectedRows: [] 
        }, (prevState) => {
          this.GetList();
        });
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, text: response.data.message, icon: response.data.success === true ? 'success' : 'error', showConfirmButton: true, allowOutsideClick: false })
      } else {
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, text: response.data.message, icon: response.data.success === true ? 'success' : 'error', showConfirmButton: true, allowOutsideClick: false })
        this.setState({ loadingList: true,postLoading:false, });
      }

    }).catch((error)=>{
            console.log("ERROR",error);
            Swal.fire({ 
                title: `<strong>Failed</strong>`, 
                text: 'Opps...! Something went wrong.', 
                icon: 'error', 
                showConfirmButton: true,
                allowOutsideClick:false, 
            });
        }).finally(this.setState({postLoading:false,}));
  };

  getInfo=(row)=>{

    this.setState({
        viewEmployeeGoalsLogs:true,
        employeeGoalsRows: row?.employee_goals || []
    });

  }


  handleInputSearch = (e) => {
    this.GetList();
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    },()=>{
        if(!e.target.value){
            this.GetList();
        }
    })
  };


  handleCheckboxChange = (employeeData) => {
    this.setState((prevState) => {
      let selectedRows = [...prevState.selectedRows];
      const isSelected = selectedRows.some(row => row.employee_id === employeeData?.employee_id);
      if (isSelected) {
          const temp=selectedRows.filter(row => row.employee_id !== employeeData?.employee_id);
        selectedRows=[...temp];
      } else {
        selectedRows.push({
            employee_id: employeeData?.employee_id,
            employee_name: employeeData?.employee_name,
            employee_code: employeeData?.employee_code,
        });
      }

      return { selectedRows };
    });
  };

  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedRows = prevState.selectedRows.length === prevState.rows.length
        ? []
        : prevState.rows.map((row) =>{
            return {employee_id: row?.employee_id, employee_name: row?.employee_name, employee_code: row?.employee_code}
        });

      return { selectedRows };
    });
  };

  handleSelectAllDropdown = (action) => {
    if (action === 'select-all') {
      this.setState({ selectedRows: this.state.rows.map((row) => row.employee_id) });
    } else if (action === 'deselect-all') {
      this.setState({ selectedRows: [] });
    }
  };


  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
            if(this.state.rows?.length>0){
                this.GetList();
            }
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
            if(this.state.rows?.length>0){
                this.GetList();
            }
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        if(this.state.rows?.length>0){
            this.GetList();
        }
      }
    );
  };

  handleSelectChange = (name, selectedOption) => {

    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  handleMultiSelect = (fieldName, selectedOptions) => {
    if (selectedOptions.some(option => option.value === "All")) {
        // Get all options except "All"
        const ids = this.state.goals_rows
            ? this.state.goals_rows
                  .filter(option => option.value !== "All")
                  .map(option => option.value)
            : [];
        console.log(ids.join(','));
        this.setState({ [fieldName]: ids.join(',') },()=> console.log("goal_id 1",this.state.goal_id));
    } else {
        const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
        this.setState({ [fieldName]: ids.join(',') },()=> console.log("goal_id 2",this.state.goal_id));
    }
};
  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        if(this.state.rows?.length>0){
            this.GetList();
        }
      }
    );
  };
  handleClearAll = () => {
    this.setState(
      {
        location_id: '',
        department_id: '',
        location_shift_id: '',
        reporting_manager_employee_id: '',
        keyword: "",
        rows: [],
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false,
        postLoading: false,
      },
      () => {
        this.GetList();
      }
    );
  };

  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500, ];

    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Assign Goals`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className='col-md-3'>
                        <label htmlFor="keyword">Search By Name</label>
                        <div className="input-group">
                          <input type="search" className="form-control" 
                          onChange={this.handleInputChange} name="keyword" 
                          value={this.state.keyword} aria-label="Recipient's username" 
                          aria-describedby="button-addon2" placeholder="Enter Name" />
                           {/* <TooltipComponent name="Search" position="bottom"> */}
                            <button className="btn btn-success" 
                            onClick={() => { if ( this.state.keyword && !this.state.loadingSearch ) { this.setState({ loadingSearch:true },()=>{ this.handleInputSearch(); }) } }}
                            type="button" id="button-addon2">
                            {this.state.loadingSearch ? (
                            <span class="spinner-border flex-shrink-0" role="status" style={{ width: "0.8rem", height: "0.8rem", borderWidth: "2px", }}>
                                <span class="visually-hidden">Loading...</span>
                            </span>
                            ) : (
                            <i className="ri-search-line"></i>
                            )}
                            </button>
                            {/* </TooltipComponent> */}
                        </div>
                      </div>

                      {/* <div className="col-md-3 ">
                        <label htmlFor="Employee" className="form-label" > Search & Select Reporting Manager </label>
                        <Select
                          onInputChange={(e) => this.setState({ emp_keyword: e }, () => { this.GetEmployeesOptionList() })}
                          options={this.state.empOptions}
                          onChange = {(selectedOption) => this.handleSelectChange('reporting_manager_employee_id', selectedOption)}
                          placeholder={`Enter Reporting Manager Code Or Name`}
                        />
                      </div> */}

                      {/* search employees under selected reporting manager */}
                      {/* <div className='col-md-3'>
                        <div>
                          <label>Search & Select Reporting Manager</label>
                        </div>
                        <Select
                          options = {this.state.empOptions}
                          value = {this.state.reporting_manager_employee_id ? this.state.empOptions.find(option => option.value === this.state.reporting_manager_employee_id) : null}
                          onChange = {(selectedOption) => this.handleSelectChange('reporting_manager_employee_id', selectedOption)}
                          placeholder={`Select Reporting Manager`}
                        />
                      </div> */}
                      {/* search employees under selected reporting manager */}

                      <div className='col-md-3 position-relative mb-5'>
                        <div>
                          <label>Location</label>
                        </div>
                        <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                        <Select
                          options={this.state.get_location_row}
                          value={this.state.location_id ? this.state.get_location_row.find(option => option.value === this.state.location_id) : null}
                          onChange={(selectedOption) => this.handleSelectChange('location_id', selectedOption)}
                          placeholder={`Select Location`}
                        />
                      </div>
                      </div>
                      <div className='col-md-3 position-relative mb-5'>
                        <div>
                          <label>Department</label>
                        </div>
                        <div style={{ "zIndex": 9, "width": "90%" }} className=' position-absolute'>
                        <Select
                          onChange={(selectedOption) => this.handleSelectChange('department_id', selectedOption)}
                          placeholder={`Select Department`}
                          options={this.state.department_row}
                          value={this.state.department_id ? this.state.department_row.find((option) => option.value === this.state.department_id) : null}
                        />
                        </div>
                        
                      </div>
                        {/* <div className='col-md-3'>
                            <div className=" d-flex align-items-center gap-2"> */}
                                <div className='col-lg-2 col-md-3 col-6 '>
                                  <div><label>Apply Filter</label></div>
                                  {/* <button
                                      type="button"
                                      onClick={this.handleInputSearch}
                                      disabled={!this.state.location_id && !this.state.department_id && !this.state.location_shift_id && !this.state.reporting_manager_employee_id}
                                      className={`w-100 noWrap btn btn-info btn-label waves-effect waves-light`}>
                                      <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                      Filter
                                  </button> */}
                                  <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "1"},()=>{this.handleInputSearch()})}} 
                                  disabled={!this.state.keyword && !this.state.location_id && !this.state.department_id && !this.state.designation_id}
                                  loading={this.state.loadingFilter==="1"} loadingMessage='Loading' 
                                  buttonName={"Filter"}  type='info' icon='ri-filter-3-fill' />
                                </div>
                                <div className='col-lg-2 col-md-3 col-6 '>
                                  <div><label className="noWrap">Clear Filter</label></div>
                                  {/* <button
                                      type="button"
                                      disabled={!this.state.location_id && !this.state.department_id && !this.state.location_shift_id && !this.state.reporting_manager_employee_id}
                                      className={`w-100 btn noWrap btn-secondary btn-label waves-effect waves-light`}
                                      onClick={this.handleClearAll}
                                  >
                                      <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> 
                                      Clear
                                  </button> */}
                                  <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "2"},()=>{this.handleClearAll()})}} 
                                  disabled={!this.state.keyword && !this.state.location_id && !this.state.department_id && !this.state.designation_id}
                                  loading={this.state.loadingFilter==="2"} loadingMessage='Loading' 
                                  buttonName={"Clear"}  type='secondary' icon='ri-database-2-line' />
                                </div>
                                
                            {/* </div>
                        </div> */}
                            <div className=" row mt-2">
                                <div className='col-md-3'>
                                {this.state.decodedData?.includes(2) && (
                                <div>
                                    <label>Assign Goal</label>
                                </div>)}
                                {this.state.decodedData?.includes(2) && (
                                // <button type="button" onClick={()=>{ this.setState({assignGoalsModal:true}); }}
                                //     className={`btn noWrap btn-primary btn-label waves-effect waves-light ${(this.state.selectedRows.length === 0) ? 'disabled' : ''}`}>
                                //     <i className="ri-user-settings-line label-icon align-middle fs-16 ms-2" />
                                //     Assign
                                // </button>
                                <SubmitButton otherClasses='noWrap' onClick={()=>{ this.setState({assignGoalsModal:true}) }} 
                                disabled={this.state.selectedRows.length === 0}
                                buttonName={"Assign"}  type='primary' icon='ri-user-settings-line' />
                              )} 
                            </div>
                          </div>
                    </div>
                  </div>
                  <div className="card-body">                  
                    <div style={{  "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                      <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                        <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                            <tr style={{ width:"5%"}} >
                                {Array.isArray(this.state.rows) && this.state.rows?.length>=1 && (
                                    <th>
                                        <div className=" d-flex gap-1 align-items-center justify-content-center" >
                                          <input type="checkbox" className="form-check-input" checked={ this.state.selectedRows.length === this.state.rows.length} onChange={this.handleSelectAll} />
                                          Select {this.state.selectedRows?.length>0 && <span className=' text-light'>({this.state.selectedRows?.length})</span>}
                                        </div>
                                    </th>
                                )}
                            <th style={{ width:"8%"}} className=" noWrap">Employee Code</th>
                            <th className="noWrap">Employee Name</th>
                            <th>Department</th>
                            <th>Designation</th>
                            <th>Location</th>
                            <th style={{ width:"8%"}} className=" text-center noWrap">Assigned Goals</th>
                            {this.state.decodedData?.includes(1) && (
                            <th>Action</th>)}
                            </tr>
                        </thead>
                        {Array.isArray(this.state.rows) && this.state.rows.length === 0 ? (
                            <tbody>
                            <tr>
                                <td colSpan={11}>
                                <NoRecords />
                                </td>
                            </tr>
                            </tbody>
                        ) :
                            <tbody>
                            {Array.isArray(this.state.rows) && this.state.rows.map((row) => {
                                return (
                                <tr key={row.employee_id}>
                                    {this.state.rows.length>0 && (
                                    <td >
                                    <div className="d-flex justify-content-center align-items-center">
                                        <input type="checkbox" className="form-check-input" 
                                        checked={this.state.selectedRows.some(val => val.employee_id === row?.employee_id)} 
                                        onChange={() => this.handleCheckboxChange(row)} />
                                    </div>
                                    </td>)}
                                    <td>{row.employee_code}</td>
                                    <td>{row.employee_name}</td>
                                    <td>{row.department_title}</td>
                                    <td>{row.designation_title}</td>
                                    <td>{row.location_title}</td>
                                    <td>
                                        <div
                                            style={{ fontSize: "0.65rem" }}
                                            className={` bg-${row?.assigned_classes} text-white fw-semibold px-1 text-center py-1  rounded-4`}
                                        >
                                            {row?.assigned_goals>1? `${row?.assigned_goals} Goals`: row?.assigned_goals==1?`${row?.assigned_goals} Goal`:`Not Assigned`}
                                        </div>
                                    </td>
                                    {this.state.decodedData?.includes(1) && (
                                    <td>
                                        <div className="d-flex justify-content-around gap-2">
                                        {this.state.decodedData?.includes(1) && (
                                            <TooltipComponent name="View Assigned goals" position="bottom">
                                                <button
                                                    onClick={() =>{
                                                        this.getInfo(row);
                                                    }}
                                                    type="button"
                                                    className="btn-icon btn btn-sm btn-outline-success mr-2 text-center"
                                                    > 
                                                    <i className="ri-file-info-line"></i>
                                                </button>
                                            </TooltipComponent>
                                        )}
                                        </div>
                                    </td>)}
                                </tr>
                                );
                            })}
                            </tbody>}
                        </table>
                    </div>
                    <div className="d-flex justify-content-between bg-light align-items-center flex-wrap w-100 py-2 px-2" >
                        {/* <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button> */}
                        <SubmitButton onClick={()=>{ this.handlePrev() }} 
                        disabled={this.state.prev === false && this.state.loadingList === false}
                        buttonName={"Previous"}  type='warning' icon='ri-arrow-left-line' />
                        <SubmitButton otherClasses='d-md-none d-block' iconSide='right' onClick={()=>{ this.handleNext() }} 
                        disabled={this.state.next === false && this.state.loadingList === false}
                        buttonName={"Next"}  type='primary' icon='ri-arrow-right-line' />

                        <div className='col-md-4 col-12 my-md-0 my-2' style={{ display: 'flex', alignItems: 'center' }}>
                            {
                                <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                            }
                        </div>
                        <div className='col-md-2'>
                            <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                {Array.from({ length: this.state.total_pages }, (_, i) => (
                                    <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                {this.state.rows?.length>0 && (
                                    <option value={this.state.rows?.length}>
                                      All
                                    </option>
                                )}
                                {limitOptions.map((option) => (
                                    <option key={option} value={option}>
                                      Limit {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {/* <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button> */}
                        <SubmitButton otherClasses='d-md-block d-none' iconSide='right' onClick={()=>{ this.handleNext() }} 
                        disabled={this.state.next === false && this.state.loadingList === false}
                        buttonName={"Next"}  type='primary' icon='ri-arrow-right-line' />
                    </div>
                    {/* <tfoot className="table-light">
                            <tr>
                            <th colSpan={8}>
                                <div className="d-flex justify-content-between">
                                <button
                                    disabled={
                                    this.state.prev === false &&
                                        this.state.loadingList === false
                                        ? true
                                        : false
                                    }
                                    type="button"
                                    onClick={() => this.handlePrev()}
                                    className={`btn btn-warning btn-label waves-effect waves-light`}
                                >
                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                    Previous
                                </button>
                                <div
                                    className="col-md-4"
                                    style={{ display: "flex", alignItems: "center" }}
                                >
                                    {
                                    <small>
                                        Total Records: {this.state.total_records} |
                                        Total Pages: {this.state.total_pages} |
                                        Current Page: {this.state.page}
                                    </small>
                                    }
                                </div>
                                <div className="col-md-2">
                                    <select
                                    className="form-select"
                                    onChange={(e) => this.handleChange(e)}
                                    >
                                    {Array.from(
                                        { length: this.state.total_pages },
                                        (_, i) => (
                                        <option
                                            selected={this.state.page === i + 1}
                                            key={i}
                                            value={i + 1}
                                        >
                                            Page {i + 1}
                                        </option>
                                        )
                                    )}
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <select
                                    className="form-select"
                                    onChange={this.handleLimitChange}
                                    value={this.state.limit}
                                    >
                                    {limitOptions.map((option) => (
                                        <option key={option} value={option}>
                                        Limit {option}
                                        </option>
                                    ))}
                                    </select>
                                </div>
                                <button
                                    disabled={
                                    this.state.next === false &&
                                        this.state.loadingList === false
                                        ? true
                                        : false
                                    }
                                    type="button"
                                    onClick={() => this.handleNext()}
                                    className={`btn btn-primary btn-label waves-effect right waves-light`}
                                >
                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                    Next
                                </button>
                                </div>
                            </th>
                            </tr>
                        </tfoot> */}
                  </div>
                </div>
                {this.state.assignGoalsModal && (
                    <div className="modal show"  style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}  >
                    <div className=" m-auto mt-4 w-modal">
                      <div className="modal-content">
                        <div className="modal-header pb-0">
                          <h5 className="modal-title" id="rmModalLabel">Assign goal</h5>
                          <button type="button" className="btn-close" onClick={()=> this.setState({ assignGoalsModal:false,goal_id:"", selectedRows:[]})} aria-label="Close" />
                        </div>
                        <div className="modal-body pt-0">
                            <div className=" row">
                                    <div className="col-md-6 mt-2">
                                        <label className="form-label" >PMS Cycle</label>
                                        <Select
                                        onChange={(selectedOption) => this.handleSelectChange('pms_cycle_id', selectedOption)}
                                        placeholder={`Select Cycle`}
                                        options={this.state.pms_cycle_rows}
                                        value={this.state.pms_cycle_id ? this.state.pms_cycle_rows.find((option) => option.value == this.state.pms_cycle_id) : null}
                                        />
                                    </div>
                                    {/* <div className="col-md-6"> */}
                                    <div className='col-md-3 mt-2'>
                                    <TextBox type="Date" id="start_date" name="start_date" label="Start date" value={this.state.start_date} change={this.handleInputChange} />
                                </div>
                                <div className='col-md-3 mt-2'>
                                    <TextBox type="Date" id="end_date" name="end_date" label="End date" value={this.state.end_date} change={this.handleInputChange} />
                                </div>
                                      {/* </div> */}
                                {/* <div className="col-md-6 ">
                                    <label className="form-label" >Goals</label>
                                    <Select
                                    onChange={(selectedOption) => this.handleSelectChange('goal_id', selectedOption)}
                                    placeholder={`Select Goal`}
                                    options={this.state.goals_rows}
                                    value={this.state.goal_id ? this.state.goals_rows.find((option) => option.value == this.state.goal_id) : null}
                                    />
                                </div> */}
                                <div className="col-md-3 mt-2">
                                    <label>Select Goals</label>
                                    <Select
                                    ref={this.sourceDiv1Ref}
                                    onChange={(selectedOptions) => this.handleMultiSelect("goal_id", selectedOptions)}
                                    placeholder={"Select Goals"}
                                    isMulti
                                    options={this.state.goals_rows}
                                    value={this.state.goal_id ? this.state.goal_id.split(',').map(id => this.state.goals_rows.find(option => option.value == id)) : null}
                                />
                                </div>

                                {/* <div className='col-md-6'>
                                    <TextBox type="Date" id="start_date" name="start_date" label="Start date" value={this.state.start_date} change={this.handleInputChange} />
                                </div>
                                <div className='col-md-6'>
                                    <TextBox type="Date" id="end_date" name="end_date" label="End date" value={this.state.end_date} change={this.handleInputChange} />
                                </div> */}
                            </div>
                        </div>
                        <div className="modal-footer">
                        {!this.state.postLoading? 
                            <button
                            type="button"
                            onClick={this.handleSubmit}
                            disabled={!this.state.pms_cycle_id || !this.state.goal_id || !this.state.start_date || !this.state.end_date}
                            className="btn noWrap btn-success btn-label waves-effect waves-light"
                            >
                            <i className=" ri-save-line label-icon align-middle fs-16 ms-2"></i>
                                Assign
                            </button>:
                            <button className="btn btn-success btn-load">
                                <span className="d-flex align-items-center">
                                    <span className="spinner-border flex-shrink-0" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </span>
                                    <span className="flex-grow-1 ms-2">
                                        Processing...
                                    </span>
                                </span>
                            </button>
                        }
                        <button type="button" className="btn btn-light" onClick={()=> this.setState({ assignGoalsModal:false, goal_id})}>Close</button>

                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {this.state.viewEmployeeGoalsLogs && (
                    <div className="modal show" 
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                    }}  >
                    <div className="modal-dialog modal-xl"
                        style={{ width: "60%" }}>
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title" id="rmModalLabel">Employee Assigned Goals</h5>
                          <button type="button" className="btn-close" onClick={()=> this.setState({ viewEmployeeGoalsLogs:false })} aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            
                            <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                    <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                        <tr>
                                            <th style={{ width:"10%"}} className="text-center">Sr.No.</th>
                                            <th>Assign Date</th>
                                            <th>Goal Title</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Status</th>
                                            {/* <th  style={{ width:"10%"}} className="text-center">Status</th> */}
                                        </tr>
                                    </thead>
                                    {Array.isArray(this.state.employeeGoalsRows) && this.state.employeeGoalsRows.length === 0 ? (
                                        <tbody>
                                        <tr>
                                            <td colSpan={11}>
                                            <NoRecords />
                                            </td>
                                        </tr>
                                        </tbody>
                                    ) :
                                        <tbody>
                                        {Array.isArray(this.state.employeeGoalsRows) && this.state.employeeGoalsRows.map((row,idx) => {
                                            return (
                                            <tr key={row.employee_id}>
                                                <td className="text-center">{idx+1}</td>
                                                <td>{row.updated_date? formatDateAndTime(row.updated_date)?.split("T")[0]:"--"}</td>
                                                <td>{row.goal_title}</td>
                                                <td>{row.goal_start_date? formatDateAndTime(row.goal_start_date)?.split("T")[0]:"--"}</td>
                                                <td>{row.goal_end_date? formatDateAndTime(row.goal_end_date)?.split("T")[0]:"--"}</td>
                                                <td>
                                                    <div
                                                        style={{ fontSize: "0.65rem" }}
                                                        className={` bg-${row?.GoalStatusClasses} ${row?.GoalStatusClasses==="light"? "text-dark":"text-white"} fw-semibold px-1 text-center py-1  rounded-4`}
                                                    >
                                                        {row?.GoalStatus}
                                                    </div>
                                                </td>
                                            </tr>
                                            );
                                        })}
                                        </tbody>}
                                        {/* <tfoot className="table-light">
                                            <tr>
                                            <th colSpan={8}>
                                                <div className="d-flex justify-content-between">
                                                <button
                                                    disabled={
                                                    this.state.prev === false &&
                                                        this.state.loadingList === false
                                                        ? true
                                                        : false
                                                    }
                                                    type="button"
                                                    onClick={() => this.handlePrev()}
                                                    className={`btn btn-warning btn-label waves-effect waves-light`}
                                                >
                                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                    Previous
                                                </button>
                                                <div
                                                    className="col-md-4"
                                                    style={{ display: "flex", alignItems: "center" }}
                                                >
                                                    {
                                                    <small>
                                                        Total Records: {this.state.total_records} |
                                                        Total Pages: {this.state.total_pages} |
                                                        Current Page: {this.state.page}
                                                    </small>
                                                    }
                                                </div>
                                                <div className="col-md-2">
                                                    <select
                                                    className="form-select"
                                                    onChange={(e) => this.handleChange(e)}
                                                    >
                                                    {Array.from(
                                                        { length: this.state.total_pages },
                                                        (_, i) => (
                                                        <option
                                                            selected={this.state.page === i + 1}
                                                            key={i}
                                                            value={i + 1}
                                                        >
                                                            Page {i + 1}
                                                        </option>
                                                        )
                                                    )}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <select
                                                    className="form-select"
                                                    onChange={this.handleLimitChange}
                                                    value={this.state.limit}
                                                    >
                                                    {limitOptions.map((option) => (
                                                        <option key={option} value={option}>
                                                        Limit {option}
                                                        </option>
                                                    ))}
                                                    </select>
                                                </div>
                                                <button
                                                    disabled={
                                                    this.state.next === false &&
                                                        this.state.loadingList === false
                                                        ? true
                                                        : false
                                                    }
                                                    type="button"
                                                    onClick={() => this.handleNext()}
                                                    className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                >
                                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                    Next
                                                </button>
                                                </div>
                                            </th>
                                            </tr>
                                        </tfoot> */}
                                </table>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(AssignGoals);
